import React from 'react';
import { Row, Col, Button, Table } from 'react-bootstrap';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { injectIntl, FormattedDate } from 'react-intl';
import moment from 'moment';
import 'moment-timezone';
import { isEmpty as _isEmpty, includes as _includes } from 'lodash';

import { addNotification } from 'actions/NotificationsActions';
import { formStatusDispatchHelper, formReset } from 'actions/FormStatusActions';

import ServiceRequestDetails from 'components/layout/connectme/ServiceRequestDetails';
import Pagination from 'components/layout/Pagination';

class ServiceRequestList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      shownIndex: null,
    };
  }

  handleClick = index => {
    this.setState(prevState => ({ shownIndex: index === prevState.shownIndex ? null : index }));
  };

  getRowIndicatorStyle = serviceRequest => {
    if (serviceRequest.action_required) {
      return { borderLeft: '10px solid #e03a3a' };
    }
    if (!_isEmpty(serviceRequest.resubmission_date) && moment(serviceRequest.resubmission_date).isBefore(moment())) {
      return { borderLeft: '10px solid #ffa000' };
    }
    return { borderLeft: '10px solid #e0e0e0' };
  };

  getRowClass = serviceRequest => {
    if (serviceRequest.action_required) {
      return 'danger bold';
    }
    if (!_isEmpty(serviceRequest.resubmission_date) && moment(serviceRequest.resubmission_date).isBefore(moment())) {
      return 'warning';
    }
    return '';
  };

  getStatus = serviceRequest => {
    if (!_isEmpty(serviceRequest.task_status)) {
      return serviceRequest.task_status;
    }
    return serviceRequest.action_required ? 'Manuelle Bearbeitung notwendig' : serviceRequest.offer_status;
  };

  setIgnored = serviceRequest => {
    serviceRequest.taskStatus = 'Ignorieren';
    serviceRequest.actionRequired = false;

    serviceRequest.task_status = 'Ignorieren';
    serviceRequest.action_required = false;

    this.props.onSubmit(serviceRequest.id, serviceRequest);

    if (this.props.onServiceRequestChanged) {
      this.props.onServiceRequestChanged(serviceRequest);
    }
  };

  setToSent = serviceRequest => {
    serviceRequest.taskStatus = 'Manuell Versendet';
    serviceRequest.actionRequired = false;
    serviceRequest.sent = true;
    serviceRequest.sentDate = moment();
    serviceRequest.resubmissionDate = moment().add(7, 'days');

    serviceRequest.task_status = 'Manuell Versendet';
    serviceRequest.action_required = false;
    serviceRequest.sent = true;
    serviceRequest.sent_date = moment();
    serviceRequest.resubmission_date = moment().add(7, 'days');

    this.props.onSubmit(serviceRequest.id, serviceRequest);

    if (this.props.onServiceRequestChanged) {
      this.props.onServiceRequestChanged(serviceRequest);
    }
  };

  setToServiceAppointmentAgreed = serviceRequest => {
    serviceRequest.taskStatus = 'Servicetermin vereinbart';
    serviceRequest.actionRequired = false;
    serviceRequest.resubmissionDate = null;

    serviceRequest.task_status = 'Servicetermin vereinbart';
    serviceRequest.action_required = false;
    serviceRequest.resubmission_date = null;

    this.props.onSubmit(serviceRequest.id, serviceRequest);

    if (this.props.onServiceRequestChanged) {
      this.props.onServiceRequestChanged(serviceRequest);
    }
  };

  render() {
    const { user, serviceRequestList, colSpan } = this.props;
    const { shownIndex } = this.state;

    let tBody = [];
    if (serviceRequestList.data.list.length) {
      tBody = serviceRequestList.data.list.map((serviceRequest, i) => {
        return (
          <tr key={i} className={this.getRowClass(serviceRequest)}>
            <td
              style={this.getRowIndicatorStyle(serviceRequest)}
              onClick={() => {
                this.handleClick(i);
              }}
            >
              {serviceRequest.vin}
            </td>
            <td
              onClick={() => {
                this.handleClick(i);
              }}
            >
              <div>{_includes(serviceRequest.offer_type, 'Wartung') ? 'Wartung' : serviceRequest.offer_type}</div>
              <div>{_isEmpty(serviceRequest.service_name) ? '' : serviceRequest.service_name}</div>
              <div>{serviceRequest.action_required && !_isEmpty(serviceRequest.note) ? serviceRequest.note : ''}</div>
            </td>
            <td
              onClick={() => {
                this.handleClick(i);
              }}
            >
              {this.getStatus(serviceRequest)}
            </td>
            <td
              onClick={() => {
                this.handleClick(i);
              }}
            >
              {serviceRequest.customer_first_name} {serviceRequest.customer_last_name}
            </td>
            <td
              onClick={() => {
                this.handleClick(i);
              }}
            >
              {_isEmpty(serviceRequest.cdate) ? (
                '-'
              ) : (
                <FormattedDate value={new Date(moment.tz(serviceRequest.cdate, 'UTC').tz(user.profile.timezone))} />
              )}
            </td>
            <td
              onClick={() => {
                this.handleClick(i);
              }}
            >
              {_isEmpty(serviceRequest.sent_date) ? (
                '-'
              ) : (
                <FormattedDate value={new Date(moment.tz(serviceRequest.sent_date, 'UTC').tz(user.profile.timezone))} />
              )}
            </td>
            <td
              onClick={() => {
                this.handleClick(i);
              }}
            >
              {_isEmpty(serviceRequest.resubmission_date) ? (
                '-'
              ) : (
                <FormattedDate
                  value={new Date(moment.tz(serviceRequest.resubmission_date, 'UTC').tz(user.profile.timezone))}
                />
              )}
            </td>
            <td>
              {serviceRequest.action_required ? (
                <Button
                  class="m-r-10"
                  bsSize="sm"
                  type="submit"
                  bsStyle="danger"
                  onClick={() => {
                    this.setIgnored(serviceRequest);
                  }}
                >
                  Ignorieren
                </Button>
              ) : null}
              {serviceRequest.action_required ? (
                <Button
                  class="m-r-10"
                  bsSize="sm"
                  type="submit"
                  bsStyle="info"
                  onClick={() => {
                    this.setToSent(serviceRequest);
                  }}
                >
                  Als <b>"Versendet"</b> markieren
                </Button>
              ) : null}
              {serviceRequest.sent &&
              serviceRequest.action_required === false &&
              serviceRequest.task_status !== 'Servicetermin vereinbart' ? (
                <Button
                  class="m-r-10"
                  bsSize="sm"
                  type="submit"
                  style={{ backgroundColor: '#4CAF50', color: '#FFF', borderColor: '#4CAF50' }}
                  onClick={() => {
                    this.setToServiceAppointmentAgreed(serviceRequest);
                  }}
                >
                  Als <b>"Servicetermin vereinbart"</b> markieren
                </Button>
              ) : null}
              {_isEmpty(serviceRequest.pdf_file) ? (
                ''
              ) : (
                <a class="btn btn-sm btn-info" href={serviceRequest.pdf_file.web_link} target="_blank">
                  <i class="fa-fw fas fa-file-pdf" /> PDF
                </a>
              )}
            </td>
          </tr>
        );
      });
    }

    if (shownIndex !== null) {
      // user wants to see details of a business
      tBody.splice(
        shownIndex + 1,
        0,
        <ServiceRequestDetails
          data={serviceRequestList.data.list[shownIndex]}
          colSpan={8}
          key="serviceRequestDetails"
        />
      );
    }

    return (
      <Row>
        <Col xs={12} class="p-b-30">
          <Table responsive hover condensed class="table-detailed dataTable">
            <thead>
              <tr>
                <th style={{ width: '205px' }}>FIN</th>
                <th style={{ width: '280px' }}>Angebotstyp</th>
                <th style={{ width: '195px' }}>Status</th>
                <th style={{ width: '200px' }}>Kunde</th>
                <th style={{ width: '100px' }}>Angelegt</th>
                <th style={{ width: '105px' }}>Versendet</th>
                <th style={{ width: '90px' }}>WVL</th>
                <th>Aktionen</th>
              </tr>
            </thead>
            <ReactCSSTransitionGroup
              transitionName="tablerows"
              transitionEnterTimeout={500}
              transitionLeaveTimeout={1}
              component="tbody"
            >
              {tBody}
            </ReactCSSTransitionGroup>
          </Table>

          {serviceRequestList.data.count > 0 ? (
            <Pagination
              count={serviceRequestList.data.count}
              resPerPage={serviceRequestList.resPerPage}
              activePage={serviceRequestList.activePage}
              handleSelect={this.handlePagination}
            />
          ) : (
            <Row>
              <Col md={12}>
                <div>Keine Daten vorhanden</div>
              </Col>
            </Row>
          )}
        </Col>
      </Row>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onSubmit: (serviceRequestId, args) => {
      formStatusDispatchHelper(
        'serviceRequestEdit',
        '/api/plugin/connectme/servicerequests/' + serviceRequestId + '.json',
        args,
        'put',
        dispatch
      );
    },
    onFormSuccessfull: () => {
      dispatch(formReset('serviceRequestEdit'));
    },
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};
const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    projectConfig: state.data.projectConfig,
    user: state.login.user,
    formStatus: state.formStatus.serviceRequestEdit,
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ServiceRequestList)
  )
);
